import script from "./DatenschutzView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatenschutzView.vue?vue&type=script&setup=true&lang=ts"

import "./DatenschutzView.vue?vue&type=style&index=0&id=deef7dd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-deef7dd8"]])

export default __exports__